export const SETS = [
  {
    id: 'base', type: 'base', title: 'BASE SET — 100 CARDS',
    cards: [
      {n:'1', name:'The Mandalorian\'s Escape', artist:'Claudio Aboy'},
      {n:'2', name:'Padmé Amidala vs. the Nexu', artist:'Kristen Plescow'},
      {n:'3', name:'Anakin Skywalker\'s Sunset', artist:'Uzuri Art'},
      {n:'4', name:'General Grievous', artist:'Annie Wu'},
      {n:'5', name:'Battle of Endor', artist:'BalanceSheet'},
      {n:'6', name:'Carbonite', artist:'Daniel Govar'},
      {n:'7', name:'On Hoth', artist:'Zoltan Boros/Gabor Szikszai'},
      {n:'8', name:'C-3PO & Babu Frik', artist:'Robert Jiménez'},
      {n:'9', name:'Cassian Andor & K-2SO', artist:'Uzuri Art'},
      {n:'10', name:'Chewbacca On Hoth', artist:'Daniel Horne'},
      {n:'11', name:'The Knights Of Ren', artist:'Anthony Feliciano'},
      {n:'12', name:'The Dark Lord', artist:'Jerry Vanderstelt'},
      {n:'13', name:'The Emperor', artist:'David Rabbitte'},
      {n:'14', name:'The Chosen One', artist:'Ignacio RC'},
      {n:'15', name:'Tarkin', artist:'Jerry Vanderstelt'},
      {n:'16', name:'Only Hope', artist:'Angelina Benedetti'},
      {n:'17', name:'The Queen of Naboo', artist:'Daniel Govar'},
      {n:'18', name:'It\'s A Trap!', artist:'JB Casacop'},
      {n:'19', name:'Educating Luke', artist:'Jerry Vanderstelt'},
      {n:'20', name:'Jango Fett\'s Legacy', artist:'Darrin Pepe'},
      {n:'21', name:'Jawas\' Score', artist:'Jason Thomas'},
      {n:'22', name:'Maz Kanata', artist:'BalanceSheet'},
      {n:'23', name:'The Trinity of Evil', artist:'Daniel Govar'},
      {n:'24', name:'Cloud City Escape', artist:'David Rabbitte'},
      {n:'25', name:'Logray', artist:'Daniel Govar'},
      {n:'26', name:'"Look Sir, Droids!"', artist:'Doug Hills'},
      {n:'27', name:'Peace Is A Lie', artist:'Jenna McMullins'},
      {n:'28', name:'FOR MANDALORE', artist:'Jodie Rae Charity'},
      {n:'29', name:'Poe Dameron & BB-8', artist:'Kristen Plescow'},
      {n:'30', name:'Qui-Gon Jinn', artist:'Robert Jiménez'},
      {n:'31', name:'Released From Carbonite', artist:'Daz Tibbles'},
      {n:'32', name:'The Rematch', artist:'David Rabbitte'},
      {n:'33', name:'Sol', artist:'Candice Dailey'},
      {n:'34', name:'Shin Hati', artist:'Uzuri Art'},
      {n:'35', name:'The Twins', artist:'Kristen Plescow'},
      {n:'36', name:'Three Bounty Hunters', artist:'Jarreau Wimberly'},
      {n:'37', name:'The Stranger', artist:'Daniel Govar'},
      {n:'38', name:'Darth Vader', artist:'Camuncoli/Bonetti'},
      {n:'39', name:'Luke Skywalker', artist:'Camuncoli/Bonetti'},
      {n:'40', name:'The Falcon Escapes', artist:'Chris Sprouse'},
      {n:'41', name:'Crait Showdown', artist:'Rich Davies'},
      {n:'42', name:'Pull To The Light', artist:'Candice Dailey'},
      {n:'43', name:'Ahsoka Tano\'s Path', artist:'Seth Groves'},
      {n:'44', name:'Trust the Force', artist:'Claudio Aboy'},
      {n:'45', name:'Darth Vader at Hoth', artist:'Victor Garduno'},
      {n:'46', name:'We Meet Again, At Last', artist:'Jaime Carrillo'},
      {n:'47', name:'Can You Speak Bocce?', artist:'Alberto "Akirant" Quirantes'},
      {n:'48', name:'Grand Master Yoda', artist:'Tommy Lee Edwards'},
      {n:'49', name:'Grogu', artist:'Archives'},
      {n:'50', name:'Save The Dream', artist:'Colin Murdoch'},
      {n:'51', name:'YAHOOO', artist:'Rob Surette'},
      {n:'52', name:'You Need A Teacher', artist:'Candice Dailey'},
      {n:'53', name:'Power of the Dark Side', artist:'Rob Surette'},
      {n:'54', name:'The Seeker', artist:'Chris Dee'},
      {n:'55', name:'What Lies Beneath!', artist:'Peter Ferk'},
      {n:'56', name:'You\'re Not Actually Going Into an Asteroid Field?', artist:'Rob Surette'},
      {n:'57', name:'Raider Ambush', artist:'Jeremy Saliba'},
      {n:'58', name:'Rebel Pilot', artist:'Dave Dorman'},
      {n:'59', name:'There Aren\'t Many Jedi Left', artist:'Mark Englert'},
      {n:'60', name:'The Savior', artist:'Andy Fairhurst'},
      {n:'61', name:'Last Look Back', artist:'Raymond Swanland'},
      {n:'62', name:'Vel Sartha', artist:'Candice Dailey'},
      {n:'63', name:'Bounty Hunters', artist:'Chris Sprouse'},
      {n:'64', name:'Machines of Dominion', artist:'Raymond Swanland'},
      {n:'65', name:'I Have You Now', artist:'Rob Surette'},
      {n:'66', name:'Through the Asteroid Field', artist:'Archives'},
      {n:'67', name:'Scarif Attack', artist:'Alberto "Akirant" Quirantes'},
      {n:'68', name:'Into the Storm', artist:'PhaseRunner'},
      {n:'69', name:'A Chilly Reception', artist:'Terese Nielsen'},
      {n:'70', name:'The Failed Execution', artist:'Archives'},
      {n:'71', name:'Unyielding', artist:'Brent Woodside'},
      {n:'72', name:'The Gift', artist:'Al Abbazia'},
      {n:'73', name:'Carbonite Captor', artist:'Jenna McMullins'},
      {n:'74', name:'Fighting Back', artist:'Chris Trevas'},
      {n:'75', name:'The Clones Advance', artist:'Brent Woodside'},
      {n:'76', name:'Solo Standoff', artist:'Mark Chilcott'},
      {n:'77', name:'Master And Apprentice', artist:'Phil Noto'},
      {n:'78', name:'Celebration On Endor', artist:'Chris Sprouse'},
      {n:'79', name:'Padmé Amidala In The Senate', artist:'Candice Dailey'},
      {n:'80', name:'Life On Hoth', artist:'Archives'},
      {n:'81', name:'Boba Fett', artist:'Greg Lipton'},
      {n:'82', name:'The Generals', artist:'Dave Dorman'},
      {n:'83', name:'Zorii Bliss', artist:'Derek Laufman'},
      {n:'84', name:'Rebel Base', artist:'Ralph McQuarrie'},
      {n:'85', name:'Death Star Duel', artist:'Archives'},
      {n:'86', name:'Battle In the Arena', artist:'Chris Trevas'},
      {n:'87', name:'Vulture Droids', artist:'Archives'},
      {n:'88', name:'Naboo Space Battle', artist:'Archives'},
      {n:'89', name:'Obi-Wan Kenobi On The Run', artist:'Roberto Campos'},
      {n:'90', name:'Lando Calrissian', artist:'Archives'},
      {n:'91', name:'Aurra Sing', artist:'Chris Trevas'},
      {n:'92', name:'Count Dooku', artist:'Tony Hsu'},
      {n:'93', name:'Life in Exile', artist:'Jerry Vanderstelt'},
      {n:'94', name:'Ahsoka Tano and Sabine Wren', artist:'Giuseppe Camuncoli'},
      {n:'95', name:'Smugglers', artist:'Zoltan Boros/Gabor Szikszai'},
      {n:'96', name:'The Royal Guard', artist:'Tommy Lee Edwards'},
      {n:'97', name:'A New Day for Luke Skywalker', artist:'Dave Dorman'},
      {n:'98', name:'Imminent Danger', artist:'Liné Tutwiler'},
      {n:'99', name:'No Squeezie!', artist:'Jodie Rae Charity'},
      {n:'100', name:'Grogu Reaches Out', artist:'Brent Woodside'},
    ]
  },
  {
    id: 'cloud-city', parallels: [{id:'green-shimmer',name:'Green Shimmer Refractor',print_run:199,color:'#00e87a'},{id:'blue-ray-wave',name:'Blue Ray Wave Refractor',print_run:175,color:'#2979ff'},{id:'atomic',name:'Atomic Refractor',print_run:150,color:'#00bcd4'},{id:'wave',name:'Wave Refractor',print_run:99,color:'#00b0ff'},{id:'prism',name:'Prism Refractor',print_run:75,color:'#e040fb'},{id:'mojo',name:'Mojo Refractor',print_run:50,color:'#ff6d00'},{id:'orange',name:'Orange Refractor',print_run:25,color:'#ff9100'},{id:'xfractor',name:'X-Fractor',print_run:10,color:'#76ff03'},{id:'red',name:'Red Refractor',print_run:5,color:'#ff1744'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'insert', title: 'DUEL ON CLOUD CITY — 15 CARDS',
    cards: [
      {n:'CLOUD-1', name:'Confronting Darth Vader', artist:'Chrstian Benavides'},
      {n:'CLOUD-2', name:'"You Are Not A Jedi, Yet"', artist:'Chrstian Benavides'},
      {n:'CLOUD-3', name:'Luke Skywalker Is Pushed Back', artist:'Chrstian Benavides'},
      {n:'CLOUD-4', name:'"All Too Easy"', artist:'Chrstian Benavides'},
      {n:'CLOUD-5', name:'Reclaiming The Lightsaber', artist:'Chrstian Benavides'},
      {n:'CLOUD-6', name:'"Release Your Anger"', artist:'Chrstian Benavides'},
      {n:'CLOUD-7', name:'Darth Vader\'s Fall', artist:'Chrstian Benavides'},
      {n:'CLOUD-8', name:'Following Darth Vader', artist:'Chrstian Benavides'},
      {n:'CLOUD-9', name:'The Duel Resumes', artist:'Chrstian Benavides'},
      {n:'CLOUD-10', name:'Luke Skywalker Flies Through The Window', artist:'Chrstian Benavides'},
      {n:'CLOUD-11', name:'"You Are Beaten"', artist:'Chrstian Benavides'},
      {n:'CLOUD-12', name:'Luke Skywalker Strikes Back', artist:'Chrstian Benavides'},
      {n:'CLOUD-13', name:'Darth Vader Cuts Off Luke Skywalker\'s Arm', artist:'Chrstian Benavides'},
      {n:'CLOUD-14', name:'The Power Of The Dark Side', artist:'Chrstian Benavides'},
      {n:'CLOUD-15', name:'"I Am Your Father"', artist:'Chrstian Benavides'},
    ]
  },
  {
    id: 'art-rogue-one', parallels: [{id:'green-shimmer',name:'Green Shimmer Refractor',print_run:199,color:'#00e87a'},{id:'blue-ray-wave',name:'Blue Ray Wave Refractor',print_run:175,color:'#2979ff'},{id:'atomic',name:'Atomic Refractor',print_run:150,color:'#00bcd4'},{id:'wave',name:'Wave Refractor',print_run:99,color:'#00b0ff'},{id:'prism',name:'Prism Refractor',print_run:75,color:'#e040fb'},{id:'mojo',name:'Mojo Refractor',print_run:50,color:'#ff6d00'},{id:'orange',name:'Orange Refractor',print_run:25,color:'#ff9100'},{id:'xfractor',name:'X-Fractor',print_run:10,color:'#76ff03'},{id:'red',name:'Red Refractor',print_run:5,color:'#ff1744'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'insert', title: 'ART OF ROGUE ONE — 15 CARDS',
    cards: [
      {n:'ARO-1', name:'Jyn Erso', artist:'Traci Easterday'},
      {n:'ARO-2', name:'Cassian Andor', artist:'Traci Easterday'},
      {n:'ARO-3', name:'K-2SO', artist:'Traci Easterday'},
      {n:'ARO-4', name:'Director Krennic', artist:'Traci Easterday'},
      {n:'ARO-5', name:'Saw Gerrera', artist:'Traci Easterday'},
      {n:'ARO-6', name:'Admiral Raddus', artist:'Traci Easterday'},
      {n:'ARO-7', name:'Galen Erso', artist:'Traci Easterday'},
      {n:'ARO-8', name:'Baze Malbus', artist:'Traci Easterday'},
      {n:'ARO-9', name:'Chirrut Îmwe', artist:'Traci Easterday'},
      {n:'ARO-10', name:'Bodhi Rook', artist:'Traci Easterday'},
      {n:'ARO-11', name:'Mon Mothma', artist:'Traci Easterday'},
      {n:'ARO-12', name:'Bail Organa', artist:'Traci Easterday'},
      {n:'ARO-13', name:'Darth Vader', artist:'Traci Easterday'},
      {n:'ARO-14', name:'Grand Moff Tarkin', artist:'Traci Easterday'},
      {n:'ARO-15', name:'Leia Organa', artist:'Traci Easterday'},
    ]
  },
  {
    id: 'art-dark-side', parallels: [{id:'green-shimmer',name:'Green Shimmer Refractor',print_run:199,color:'#00e87a'},{id:'blue-ray-wave',name:'Blue Ray Wave Refractor',print_run:175,color:'#2979ff'},{id:'atomic',name:'Atomic Refractor',print_run:150,color:'#00bcd4'},{id:'wave',name:'Wave Refractor',print_run:99,color:'#00b0ff'},{id:'prism',name:'Prism Refractor',print_run:75,color:'#e040fb'},{id:'mojo',name:'Mojo Refractor',print_run:50,color:'#ff6d00'},{id:'orange',name:'Orange Refractor',print_run:25,color:'#ff9100'},{id:'xfractor',name:'X-Fractor',print_run:10,color:'#76ff03'},{id:'red',name:'Red Refractor',print_run:5,color:'#ff1744'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'insert', title: 'ART OF THE DARK SIDE — 15 CARDS',
    cards: [
      {n:'ADS-1', name:'Anakin Skywalker', artist:'Taurin Clarke'},
      {n:'ADS-2', name:'Moff Gideon', artist:'Taurin Clarke'},
      {n:'ADS-3', name:'Maul', artist:'Taurin Clarke'},
      {n:'ADS-4', name:'Darth Vader', artist:'Taurin Clarke'},
      {n:'ADS-5', name:'Darth Sidious', artist:'Taurin Clarke'},
      {n:'ADS-6', name:'The Stranger', artist:'Taurin Clarke'},
      {n:'ADS-7', name:'Captain Phasma', artist:'Taurin Clarke'},
      {n:'ADS-8', name:'Savage Opress', artist:'Taurin Clarke'},
      {n:'ADS-9', name:'Fifth Brother', artist:'Taurin Clarke'},
      {n:'ADS-10', name:'Kylo Ren', artist:'Taurin Clarke'},
      {n:'ADS-11', name:'Mother Talzin', artist:'Taurin Clarke'},
      {n:'ADS-12', name:'Grand Admiral Thrawn', artist:'Taurin Clarke'},
      {n:'ADS-13', name:'Morgan Elsbeth', artist:'Taurin Clarke'},
      {n:'ADS-14', name:'Cad Bane', artist:'Taurin Clarke'},
      {n:'ADS-15', name:'Count Dooku', artist:'Taurin Clarke'},
    ]
  },
  {
    id: 'galactic-anthology', parallels: [{id:'green-shimmer',name:'Green Shimmer Refractor',print_run:199,color:'#00e87a'},{id:'blue-ray-wave',name:'Blue Ray Wave Refractor',print_run:175,color:'#2979ff'},{id:'atomic',name:'Atomic Refractor',print_run:150,color:'#00bcd4'},{id:'wave',name:'Wave Refractor',print_run:99,color:'#00b0ff'},{id:'prism',name:'Prism Refractor',print_run:75,color:'#e040fb'},{id:'mojo',name:'Mojo Refractor',print_run:50,color:'#ff6d00'},{id:'orange',name:'Orange Refractor',print_run:25,color:'#ff9100'},{id:'xfractor',name:'X-Fractor',print_run:10,color:'#76ff03'},{id:'red',name:'Red Refractor',print_run:5,color:'#ff1744'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'insert', title: 'GALACTIC ANTHOLOGY — 15 CARDS',
    cards: [
      {n:'GA-1', name:'Chewbacca and BB-8', artist:'Danny Schlitz'},
      {n:'GA-2', name:'Qui-Gon Jinn', artist:'Danny Schlitz'},
      {n:'GA-3', name:'Kanan Jarrus', artist:'Danny Schlitz'},
      {n:'GA-4', name:'Jabba the Hutt', artist:'Danny Schlitz'},
      {n:'GA-5', name:'Shin Hati', artist:'Danny Schlitz'},
      {n:'GA-6', name:'Obi-Wan Kenobi', artist:'Danny Schlitz'},
      {n:'GA-7', name:'Jar Jar Binks', artist:'Danny Schlitz'},
      {n:'GA-8', name:'Dedra Meero', artist:'Danny Schlitz'},
      {n:'GA-9', name:'Jango Fett', artist:'Danny Schlitz'},
      {n:'GA-10', name:'Jod Na Nawood', artist:'Danny Schlitz'},
      {n:'GA-11', name:'Lando Calrissian', artist:'Danny Schlitz'},
      {n:'GA-12', name:'Luthen Rael', artist:'Danny Schlitz'},
      {n:'GA-13', name:'General Grievous', artist:'Danny Schlitz'},
      {n:'GA-14', name:'Wicket W. Warrick', artist:'Danny Schlitz'},
      {n:'GA-15', name:'Asajj Ventress', artist:'Danny Schlitz'},
    ]
  },
  {
    id: 'kotor', parallels: [{id:'green-shimmer',name:'Green Shimmer Refractor',print_run:199,color:'#00e87a'},{id:'blue-ray-wave',name:'Blue Ray Wave Refractor',print_run:175,color:'#2979ff'},{id:'atomic',name:'Atomic Refractor',print_run:150,color:'#00bcd4'},{id:'wave',name:'Wave Refractor',print_run:99,color:'#00b0ff'},{id:'prism',name:'Prism Refractor',print_run:75,color:'#e040fb'},{id:'mojo',name:'Mojo Refractor',print_run:50,color:'#ff6d00'},{id:'orange',name:'Orange Refractor',print_run:25,color:'#ff9100'},{id:'xfractor',name:'X-Fractor',print_run:10,color:'#76ff03'},{id:'red',name:'Red Refractor',print_run:5,color:'#ff1744'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'insert', title: 'ART OF KNIGHTS OF THE REPUBLIC — 15 CARDS',
    cards: [
      {n:'KOTOR-1', name:'Bastila Shan', artist:'Gal Or'},
      {n:'KOTOR-2', name:'Canderous Ordo', artist:'Gal Or'},
      {n:'KOTOR-3', name:'Carth Onasi', artist:'Gal Or'},
      {n:'KOTOR-4', name:'HK-47', artist:'Gal Or'},
      {n:'KOTOR-5', name:'Jolee Bindo', artist:'Gal Or'},
      {n:'KOTOR-6', name:'Juhani', artist:'Gal Or'},
      {n:'KOTOR-7', name:'T3-M4', artist:'Gal Or'},
      {n:'KOTOR-8', name:'Mission Vao', artist:'Gal Or'},
      {n:'KOTOR-9', name:'Sith Soldier', artist:'Gal Or'},
      {n:'KOTOR-10', name:'Visas Marr', artist:'Gal Or'},
      {n:'KOTOR-11', name:'Darth Malak', artist:'Gal Or'},
      {n:'KOTOR-12', name:'HK-47 & T3-M4', artist:'Gal Or'},
      {n:'KOTOR-13', name:'Darth Sion', artist:'Gal Or'},
      {n:'KOTOR-14', name:'Atton Rand', artist:'Gal Or'},
      {n:'KOTOR-15', name:'Darth Revan', artist:'Gal Or'},
    ]
  },
  {
    id: 'chrome-layers', parallels: [{id:'orange',name:'Orange Refractor',print_run:25,color:'#ff9100'},{id:'xfractor',name:'X-Fractor',print_run:10,color:'#76ff03'},{id:'red',name:'Red Refractor',print_run:5,color:'#ff1744'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'insert', title: 'TOPPS CHROME LAYERS ORIGINAL ART — 11 CARDS',
    cards: [
      {n:'LAY-1', name:'Opee Sea Killer Hunts the Gungan Submarine', artist:'Doug Chaing'},
      {n:'LAY-2', name:'The Krayt Dragon Targets A Bantha', artist:'Doug Chaing'},
      {n:'LAY-3', name:'Count Dooku\'s Hangar', artist:'Doug Chaing'},
      {n:'LAY-4', name:'The Podracer Advances', artist:'Doug Chaing'},
      {n:'LAY-5', name:'Ravinak', artist:'Doug Chaing'},
      {n:'LAY-6', name:'Battle Droids', artist:'Doug Chaing'},
      {n:'LAY-7', name:'Gungan Sacred Place', artist:'Doug Chaing'},
      {n:'LAY-8', name:'Republic Gunships', artist:'Doug Chaing'},
      {n:'LAY-9', name:'Naboo', artist:'Doug Chaing'},
      {n:'LAY-10', name:'Battle Droids Vs Gungans', artist:'Doug Chaing'},
      {n:'LAY-11', name:'The Mudhorn', artist:'Doug Chaing'},
    ]
  },
  {
    id: 'comicfractor', parallels: [{id:'orange',name:'Orange Refractor',print_run:25,color:'#ff9100'},{id:'xfractor',name:'X-Fractor',print_run:10,color:'#76ff03'},{id:'red',name:'Red Refractor',print_run:5,color:'#ff1744'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'insert', title: 'COMICFRACTOR — 5 CARDS',
    cards: [
      {n:'VC-16', name:'Ben (Obi-Wan) Kenobi', artist:'John Tyler Christopher'},
      {n:'VC-17', name:'Ahsoka Tano', artist:'John Tyler Christopher'},
      {n:'VC-18', name:'Luke Skywalker', artist:'John Tyler Christopher'},
      {n:'VC-19', name:'Han Solo: Imperial Stormtrooper Outfit', artist:'John Tyler Christopher'},
      {n:'VC-20', name:'Imperial TIE Fighter Pilot', artist:'John Tyler Christopher'},
    ]
  },
  {
    id: 'puzzle', parallels: [{id:'orange',name:'Orange Refractor',print_run:25,color:'#ff9100'},{id:'xfractor',name:'X-Fractor',print_run:10,color:'#76ff03'},{id:'red',name:'Red Refractor',print_run:5,color:'#ff1744'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'insert', title: 'ORIGINAL ART PUZZLE CARDS — 36 CARDS',
    cards: [
      {n:'HCW-1', name:'Anakin Skywalker', artist:'Aurelio Lorenzo'},
      {n:'HCW-2', name:'Mace Windu', artist:'Aurelio Lorenzo'},
      {n:'HCW-3', name:'Kit Fisto', artist:'Aurelio Lorenzo'},
      {n:'HCW-4', name:'Padmé Amidala', artist:'Aurelio Lorenzo'},
      {n:'HCW-5', name:'Obi-Wan Kenobi', artist:'Aurelio Lorenzo'},
      {n:'HCW-6', name:'Shaak Ti', artist:'Aurelio Lorenzo'},
      {n:'HCW-7', name:'Clone Troopers', artist:'Aurelio Lorenzo'},
      {n:'HCW-8', name:'Yoda', artist:'Aurelio Lorenzo'},
      {n:'HCW-9', name:'Clone Commander Cody', artist:'Aurelio Lorenzo'},
      {n:'JC-1', name:'Yaddle', artist:'Erik Maell'},
      {n:'JC-2', name:'Saesee Tiin', artist:'Erik Maell'},
      {n:'JC-3', name:'Even Piell', artist:'Erik Maell'},
      {n:'JC-4', name:'Mace Windu', artist:'Erik Maell'},
      {n:'JC-5', name:'Yoda', artist:'Erik Maell'},
      {n:'JC-6', name:'Plo Koon', artist:'Erik Maell'},
      {n:'JC-7', name:'Eeth Koth', artist:'Erik Maell'},
      {n:'JC-8', name:'Ki-Adi-Mundi', artist:'Erik Maell'},
      {n:'JC-9', name:'Adi Gallia', artist:'Erik Maell'},
      {n:'MIMA-1', name:'The Armorer', artist:'Joe Corroney'},
      {n:'MIMA-2', name:'The Mandalorian', artist:'Joe Corroney'},
      {n:'MIMA-3', name:'Sabine Wren', artist:'Joe Corroney'},
      {n:'MIMA-4', name:'Paz Vizsla', artist:'Joe Corroney'},
      {n:'MIMA-5', name:'Grogu', artist:'Joe Corroney'},
      {n:'MIMA-6', name:'Ragnar Vizsla', artist:'Joe Corroney'},
      {n:'MIMA-7', name:'Axe Woves', artist:'Joe Corroney'},
      {n:'MIMA-8', name:'Bo-Katan Kryze', artist:'Joe Corroney'},
      {n:'MIMA-9', name:'Koska Reeves', artist:'Joe Corroney'},
      {n:'POWW-1', name:'Bix Caleen', artist:'Uzuri'},
      {n:'POWW-2', name:'Padmé Amidala', artist:'Uzuri'},
      {n:'POWW-3', name:'Hera Syndulla', artist:'Uzuri'},
      {n:'POWW-4', name:'Rey', artist:'Uzuri'},
      {n:'POWW-5', name:'Leia Organa', artist:'Uzuri'},
      {n:'POWW-6', name:'Zorii Bliss', artist:'Uzuri'},
      {n:'POWW-7', name:'Ahsoka Tano', artist:'Uzuri'},
      {n:'POWW-8', name:'Vice Admiral Holdo', artist:'Uzuri'},
      {n:'POWW-9', name:'Kleya Marki', artist:'Uzuri'},
    ]
  },
  {
    id: 'force-energy', parallels: [{id:'orange',name:'Orange Refractor',print_run:25,color:'#ff9100'},{id:'xfractor',name:'X-Fractor',print_run:10,color:'#76ff03'},{id:'red',name:'Red Refractor',print_run:5,color:'#ff1744'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'insert', title: 'FORCE ENERGY — 10 CARDS',
    cards: [
      {n:'FE-1', name:'Obi-Wan Kenobi', artist:'Shane Grammer'},
      {n:'FE-2', name:'Darth Maul', artist:'Shane Grammer'},
      {n:'FE-3', name:'Yoda', artist:'Shane Grammer'},
      {n:'FE-4', name:'Darth Sidious', artist:'Shane Grammer'},
      {n:'FE-5', name:'Luke Skywalker', artist:'Shane Grammer'},
      {n:'FE-6', name:'Darth Vader', artist:'Shane Grammer'},
      {n:'FE-7', name:'Rey', artist:'Shane Grammer'},
      {n:'FE-8', name:'Kylo Ren', artist:'Shane Grammer'},
      {n:'FE-9', name:'Mace Windu', artist:'Shane Grammer'},
      {n:'FE-10', name:'Ahsoka Tano', artist:'Shane Grammer'},
    ]
  },
  {
    id: 'auto-single', parallels: [{id:'numbered',name:'',print_run:199,color:'#c8d8f0'},{id:'atomic',name:'Atomic Refractor',print_run:150,color:'#00bcd4'},{id:'wave',name:'Wave Refractor',print_run:99,color:'#00b0ff'},{id:'mojo',name:'Mojo Refractor',print_run:50,color:'#ff6d00'},{id:'orange',name:'Orange Refractor',print_run:25,color:'#ff9100'},{id:'red',name:'Red Refractor',print_run:5,color:'#ff1744'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'auto', title: 'GALAXY AUTOGRAPHS — 61 CARDS',
    cards: [
      {n:'GA-33', name:'Nick Frost', artist:'SM-33'},
      {n:'GA-AA', name:'Adria Arjona', artist:'Bix Caleen'},
      {n:'GA-AB', name:'Ahmed Best', artist:'Jar Jar Binks'},
      {n:'GA-AD', name:'Adam Driver', artist:'Kylo Ren'},
      {n:'GA-BOY', name:'John Boyega', artist:'Finn'},
      {n:'GA-BRI', name:'Alison Brie', artist:'Am'},
      {n:'GA-BW', name:'Billy Dee Williams', artist:'Lando Calrissian'},
      {n:'GA-C3', name:'Anthony Daniels', artist:'C-3PO'},
      {n:'GA-CHEW', name:'Joonas Suotamo', artist:'Chewbacca'},
      {n:'GA-CM', name:'Carrie-Anne Moss', artist:'Jedi Master Indara'},
      {n:'GA-DG', name:'Denise Gough', artist:'Dedra Meero'},
      {n:'GA-DK', name:'Dafne Keen', artist:'Jecki Lon'},
      {n:'GA-DL', name:'Diego Luna', artist:'Cassian Andor'},
      {n:'GA-DO', name:'Domhnall Gleeson', artist:'General Hux'},
      {n:'GA-DOC', name:'Christopher Lloyd', artist:'Commissioner Helgait'},
      {n:'GA-DON', name:'Donald Faison', artist:'Hype Fazon'},
      {n:'GA-DR', name:'Daisy Ridley', artist:'Rey'},
      {n:'GA-DT', name:'David Tennant', artist:'Huyang'},
      {n:'GA-EC', name:'Emilia Clarke', artist:'Qi\'ra'},
      {n:'GA-ECK', name:'Ashley Eckstein', artist:'Ahsoka Tano'},
      {n:'GA-EM', name:'Ewan McGregor', artist:'Obi-Wan Kenobi'},
      {n:'GA-ES', name:'Emily Swallow', artist:'The Armorer'},
      {n:'GA-FJ', name:'Felicity Jones', artist:'Jyn Erso'},
      {n:'GA-FP', name:'Freddie Prinze Jr.', artist:'Kanan Jarrus'},
      {n:'GA-GT', name:'George Takei', artist:'Lok Durd'},
      {n:'GA-HC', name:'Hayden Christensen', artist:'Anakin Skywalker'},
      {n:'GA-HF', name:'Harrison Ford', artist:'Han Solo'},
      {n:'GA-IM', name:'Ian McDiarmid', artist:'Darth Sidious'},
      {n:'GA-IS', name:'Ivanna Sakhno', artist:'Shin Hati'},
      {n:'GA-JI', name:'Jason Isaacs', artist:'The Grand Inquisitor'},
      {n:'GA-JL', name:'Jake Lloyd', artist:'Anakin Skywalker'},
      {n:'GA-K', name:'Alan Tudyk', artist:'K-2SO'},
      {n:'GA-KAT', name:'Katee Sackhoff', artist:'Bo-Katan Kryze'},
      {n:'GA-KK', name:'Keira Knightley', artist:'Sabé'},
      {n:'GA-KM', name:'Kelly Macdonald', artist:'Pokkit'},
      {n:'GA-KR', name:'Keri Russell', artist:'Zorii Bliss'},
      {n:'GA-L', name:'Lizzo', artist:'The Duchess'},
      {n:'GA-LAW', name:'Jude Law', artist:'Jod Na Nawood'},
      {n:'GA-LD', name:'Laura Dern', artist:'Vice Admiral Holdo'},
      {n:'GA-LJ', name:'Lee Jung-jae', artist:'Jedi Master Sol'},
      {n:'GA-LM', name:'Lars Mikkelsen', artist:'Grand Admiral Thrawn'},
      {n:'GA-MAY', name:'Peter Mayhew', artist:'Chewbacca'},
      {n:'GA-MH', name:'Mark Hamill', artist:'Luke Skywalker'},
      {n:'GA-MI', name:'Moses Ingram', artist:'Reva'},
      {n:'GA-MJ', name:'Manny Jacinto', artist:'The Stranger'},
      {n:'GA-MW', name:'Mary Elizabeth Winstead', artist:'Hera Syndulla'},
      {n:'GA-NB', name:'Natasha Liu Bordizzo', artist:'Sabine Wren'},
      {n:'GA-NP', name:'Natalie Portman', artist:'Padmé Amidala'},
      {n:'GA-PP', name:'Pedro Pascal', artist:'The Mandalorian'},
      {n:'GA-RDAW', name:'Rosario Dawson', artist:'Ahsoka Tano'},
      {n:'GA-RH', name:'Ron Howard', artist:'Director'},
      {n:'GA-RP', name:'Ray Park', artist:'Darth Maul'},
      {n:'GA-SER', name:'Andy Serkis', artist:'Supreme Leader Snoke'},
      {n:'GA-SJ', name:'Samuel L. Jackson', artist:'Mace Windu'},
      {n:'GA-SP', name:'Simon Pegg', artist:'Unkar Plutt'},
      {n:'GA-SS', name:'Stellan Skarsgård', artist:'Luthen Rael'},
      {n:'GA-SW', name:'Sam Witwer', artist:'Darth Maul'},
      {n:'GA-TM', name:'Temuera Morrison', artist:'Boba Fett'},
      {n:'GA-TO', name:'Timothy Olyphant', artist:'Cobb Vanth'},
      {n:'GA-TW', name:'Taika Waititi', artist:'IG-11'},
      {n:'GA-WEN', name:'Ming-Na Wen', artist:'Fennec Shand'},
    ]
  },
  {
    id: 'auto-dual', parallels: [{id:'red',name:'Red Refractor',print_run:5,color:'#ff1744'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'auto', title: 'DUAL AUTOGRAPHS — 10 CARDS',
    cards: [
      {n:'D-BOUNTY', name:'Dorian Kingi / Temuera Morrison', artist:'Cad Bane / Boba Fett'},
      {n:'D-CDAWN', name:'Paul Bettany / Ray Park', artist:'Dryden Vos / Maul'},
      {n:'D-DARK', name:'Nika Futterman / Sam Witwer', artist:'Asajj Ventress / Darth Maul'},
      {n:'D-FO', name:'Domhnall Gleeson / Richard E. Grant', artist:'General Hux / General Pryde'},
      {n:'D-NABOO', name:'Keira Knightley / Ewan McGregor', artist:'Sabé / Obi-Wan Kenobi'},
      {n:'D-PIRATE', name:'Jude Law / Jaleel White', artist:'Jod Na Nawood / Gunter'},
      {n:'D-REBEL', name:'Genevieve O\'Reilly / Elizabeth Dulau', artist:'Mon Mothma / Kleya Marki'},
      {n:'D-ROTJ', name:'David Barclay / Billy Dee Williams', artist:'Jabba the Hutt / Lando Calrissian'},
      {n:'D-RULE2', name:'Ian McDiarmid / Hayden Christensen', artist:'Darth Sidious / Darth Vader'},
      {n:'D-TATOO', name:'Pedro Pascal / Ming-Na Wen', artist:'The Mandalorian / Fennec Shand'},
    ]
  },
  {
    // The base Triple Auto is the highest-print card at /5, so it needs a rule-6
    // serial slot for collectors to record which copy they own. Matches this
    // file's own convention for a numbered auto base (see auto-single /199).
    id: 'auto-triple', basePrintRun: 5, parallels: [{id:'numbered',name:'',print_run:5,color:'#c8d8f0'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'auto', title: 'TRIPLE AUTOGRAPHS — 9 CARDS',
    cards: [
      {n:'T-AHS', name:'David Tennant / Rosario Dawson / Natasha Liu Bordizzo', artist:'Huyang / Ahsoka Tano / Sabine Wren'},
      {n:'T-ANDOR', name:'Denise Gough / Stellan Skarsgård / Diego Luna', artist:'Dedra Meero / Luthen Rael / Cassian Andor'},
      {n:'T-EP6', name:'Peter Mayhew / Anthony Daniels / Harrison Ford', artist:'Chewbacca / C-3PO / Han Solo'},
      {n:'T-EP7', name:'Lupita Nyong\'o / Joonas Suotamo / Daisy Ridley', artist:'Maz Kanata / Chewbacca / Rey'},
      {n:'T-GEO', name:'Ian McDiarmid / Temuera Morrison / Samuel L. Jackson', artist:'Chancellor Palpatine / Jango Fett / Mace Windu'},
      {n:'T-HPATH', name:'Maya Erskine / Ewan McGregor / O\'Shea Jackson Jr.', artist:'Sully Stark / Obi-Wan Kenobi / Kawlan Roken'},
      {n:'T-R1', name:'Riz Ahmed / Mads Mikkelsen / Felicity Jones', artist:'Bodhi Rook / Galen Erso / Jyn Erso'},
      {n:'T-RESIST', name:'Billie Lourd / Oscar Isaac / Kelly Marie Tran', artist:'Kaydel Connix / Poe Dameron / Rose Tico'},
      {n:'T-SOLO', name:'Joonas Suotamo / Alden Ehrenreich / Paul Bettany', artist:'Chewbacca / Han Solo / Dryden Vos'},
    ]
  },
  {
    id: 'auto-quad', parallels: [{id:'red',name:'Red Refractor',print_run:5,color:'#ff1744'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'auto', title: 'QUAD BOOKLET AUTOGRAPHS — 5 CARDS',
    cards: [
      {n:'Q-ANDOR', name:'Diego Luna / Genevieve O\'Reilly / Stellan Skarsgård / Benjamin Bratt', artist:'Cassian Andor / Mon Mothma / Luthen Rael / Bail Organa'},
      {n:'Q-BESPIN', name:'Jeremy Bulloch / David Prowse / Harrison Ford / Billy Dee Williams', artist:'Boba Fett / Darth Vader / Han Solo / Lando Calrissian'},
      {n:'Q-EP8', name:'John Boyega / Gwendolie Christie / Benicio del Toro / Kelly Marie Tran', artist:'Finn / Captain Phasma / DJ / Rose Tico'},
      {n:'Q-JAKKU', name:'Dave Chapman / John Boyega / Daisy Ridley / Simon Pegg', artist:'BB-8 / Finn / Rey / Unkar Plutt'},
      {n:'Q-P15', name:'Lizzo / Christopher Lloyd / Pedro Pascal / Katee Sackhoff', artist:'The Duchess / Commissioner Helgait / The Mandalorian / Bo-Katan Kryze'},
    ]
  },
  {
    id: 'sketch', parallels: [], type: 'sketch', title: 'SKETCH CARD ARTISTS — 218 ARTISTS',
    cards: [
      {n:'SK-1', name:'Aaron Laurich', artist:'Sketch Card Artist'},
      {n:'SK-2', name:'Adam Beck', artist:'Sketch Card Artist'},
      {n:'SK-3', name:'Adam D. Perler', artist:'Sketch Card Artist'},
      {n:'SK-4', name:'Aldrich Serrano', artist:'Sketch Card Artist'},
      {n:'SK-5', name:'Aleksandr Gigov', artist:'Sketch Card Artist'},
      {n:'SK-6', name:'Alex Mines', artist:'Sketch Card Artist'},
      {n:'SK-7', name:'Alexander Diab', artist:'Sketch Card Artist'},
      {n:'SK-8', name:'Alexander McCormick', artist:'Sketch Card Artist'},
      {n:'SK-9', name:'Allen Geneta', artist:'Sketch Card Artist'},
      {n:'SK-10', name:'Allen Grimes', artist:'Sketch Card Artist'},
      {n:'SK-11', name:'Andrew Fernandes', artist:'Sketch Card Artist'},
      {n:'SK-12', name:'Andrew Fry', artist:'Sketch Card Artist'},
      {n:'SK-13', name:'ANDY TIU', artist:'Sketch Card Artist'},
      {n:'SK-14', name:'Angel Aviles', artist:'Sketch Card Artist'},
      {n:'SK-15', name:'Angelina Benedetti', artist:'Sketch Card Artist'},
      {n:'SK-16', name:'Anthony Pietszak', artist:'Sketch Card Artist'},
      {n:'SK-17', name:'Anthony Richichi', artist:'Sketch Card Artist'},
      {n:'SK-18', name:'Arlene', artist:'Sketch Card Artist'},
      {n:'SK-19', name:'ArtJay', artist:'Sketch Card Artist'},
      {n:'SK-20', name:'Ash', artist:'Sketch Card Artist'},
      {n:'SK-21', name:'Ashley Marsh', artist:'Sketch Card Artist'},
      {n:'SK-22', name:'AsylumArtz', artist:'Sketch Card Artist'},
      {n:'SK-23', name:'Barry Renshaw', artist:'Sketch Card Artist'},
      {n:'SK-24', name:'Basak Kahraman', artist:'Sketch Card Artist'},
      {n:'SK-25', name:'Bean', artist:'Sketch Card Artist'},
      {n:'SK-26', name:'Ben AbuSaada', artist:'Sketch Card Artist'},
      {n:'SK-27', name:'Bernardo Oliveira', artist:'Sketch Card Artist'},
      {n:'SK-28', name:'Bistek Javier', artist:'Sketch Card Artist'},
      {n:'SK-29', name:'Bobby Blakey', artist:'Sketch Card Artist'},
      {n:'SK-30', name:'Bradley Hudson', artist:'Sketch Card Artist'},
      {n:'SK-31', name:'Brandon Klein', artist:'Sketch Card Artist'},
      {n:'SK-32', name:'Bruce Gerlach', artist:'Sketch Card Artist'},
      {n:'SK-33', name:'Bryan Waytula', artist:'Sketch Card Artist'},
      {n:'SK-34', name:'C.Deakes', artist:'Sketch Card Artist'},
      {n:'SK-35', name:'Candice Dailey', artist:'Sketch Card Artist'},
      {n:'SK-36', name:'Carlo Allen Victoria', artist:'Sketch Card Artist'},
      {n:'SK-37', name:'Charlie Cody', artist:'Sketch Card Artist'},
      {n:'SK-38', name:'Chenduz', artist:'Sketch Card Artist'},
      {n:'SK-39', name:'Chris Colyer', artist:'Sketch Card Artist'},
      {n:'SK-40', name:'Chris Meeks', artist:'Sketch Card Artist'},
      {n:'SK-41', name:'Chris Quinn', artist:'Sketch Card Artist'},
      {n:'SK-42', name:'Chris Timola', artist:'Sketch Card Artist'},
      {n:'SK-43', name:'Christoffer Allen Victoria', artist:'Sketch Card Artist'},
      {n:'SK-44', name:'Cisco Rivera', artist:'Sketch Card Artist'},
      {n:'SK-45', name:'Court', artist:'Sketch Card Artist'},
      {n:'SK-46', name:'Cyrus Sherkat', artist:'Sketch Card Artist'},
      {n:'SK-47', name:'Dan Bergren', artist:'Sketch Card Artist'},
      {n:'SK-48', name:'Dan Cooney', artist:'Sketch Card Artist'},
      {n:'SK-49', name:'Dan Curto', artist:'Sketch Card Artist'},
      {n:'SK-50', name:'Dan Gorman', artist:'Sketch Card Artist'},
      {n:'SK-51', name:'Dan Lawler', artist:'Sketch Card Artist'},
      {n:'SK-52', name:'Dan Tearle', artist:'Sketch Card Artist'},
      {n:'SK-53', name:'Daniel Riveron', artist:'Sketch Card Artist'},
      {n:'SK-54', name:'Darrin Pepe', artist:'Sketch Card Artist'},
      {n:'SK-55', name:'Dave Wilson', artist:'Sketch Card Artist'},
      {n:'SK-56', name:'David Willingham', artist:'Sketch Card Artist'},
      {n:'SK-57', name:'Dawn Murphy', artist:'Sketch Card Artist'},
      {n:'SK-58', name:'Débora Centeio', artist:'Sketch Card Artist'},
      {n:'SK-59', name:'Don Nguyen', artist:'Sketch Card Artist'},
      {n:'SK-60', name:'Douglas Stromenger', artist:'Sketch Card Artist'},
      {n:'SK-61', name:'Dove McHargue', artist:'Sketch Card Artist'},
      {n:'SK-62', name:'Dwayne Carpenter', artist:'Sketch Card Artist'},
      {n:'SK-63', name:'DYJ', artist:'Sketch Card Artist'},
      {n:'SK-64', name:'Dylan Riley', artist:'Sketch Card Artist'},
      {n:'SK-65', name:'El Smetchö', artist:'Sketch Card Artist'},
      {n:'SK-66', name:'Elvin A Hernandez', artist:'Sketch Card Artist'},
      {n:'SK-67', name:'Eric Lehtonen', artist:'Sketch Card Artist'},
      {n:'SK-68', name:'Eric Medina', artist:'Sketch Card Artist'},
      {n:'SK-69', name:'Erik Maell', artist:'Sketch Card Artist'},
      {n:'SK-70', name:'Erik Muller', artist:'Sketch Card Artist'},
      {n:'SK-71', name:'Frank A. Kadar', artist:'Sketch Card Artist'},
      {n:'SK-72', name:'Frank Sansone', artist:'Sketch Card Artist'},
      {n:'SK-73', name:'Franklim Teixeira', artist:'Sketch Card Artist'},
      {n:'SK-74', name:'Gabe Farber', artist:'Sketch Card Artist'},
      {n:'SK-75', name:'Gary Rudisill', artist:'Sketch Card Artist'},
      {n:'SK-76', name:'Gary Shipman', artist:'Sketch Card Artist'},
      {n:'SK-77', name:'Gawanimayk', artist:'Sketch Card Artist'},
      {n:'SK-78', name:'Getatom', artist:'Sketch Card Artist'},
      {n:'SK-79', name:'Grace Riley', artist:'Sketch Card Artist'},
      {n:'SK-80', name:'Greg Treize', artist:'Sketch Card Artist'},
      {n:'SK-81', name:'Guilherme Rocha', artist:'Sketch Card Artist'},
      {n:'SK-82', name:'Henrique Pirote', artist:'Sketch Card Artist'},
      {n:'SK-83', name:'Ian McKesson', artist:'Sketch Card Artist'},
      {n:'SK-84', name:'Isiah Xavier Bradley', artist:'Sketch Card Artist'},
      {n:'SK-85', name:'Jaime Lopez', artist:'Sketch Card Artist'},
      {n:'SK-86', name:'James Boyd', artist:'Sketch Card Artist'},
      {n:'SK-87', name:'James Harris', artist:'Sketch Card Artist'},
      {n:'SK-88', name:'Jamie Richards', artist:'Sketch Card Artist'},
      {n:'SK-89', name:'Jamison Murdock', artist:'Sketch Card Artist'},
      {n:'SK-90', name:'Jane Rushton', artist:'Sketch Card Artist'},
      {n:'SK-91', name:'Jason Christner', artist:'Sketch Card Artist'},
      {n:'SK-92', name:'Jason Davies', artist:'Sketch Card Artist'},
      {n:'SK-93', name:'Jason Queen', artist:'Sketch Card Artist'},
      {n:'SK-94', name:'Jason Queen', artist:'Sketch Card Artist'},
      {n:'SK-95', name:'Jason Saldajeno', artist:'Sketch Card Artist'},
      {n:'SK-96', name:'Jason Sobol', artist:'Sketch Card Artist'},
      {n:'SK-97', name:'Jason Torres', artist:'Sketch Card Artist'},
      {n:'SK-98', name:'Jay Manchand', artist:'Sketch Card Artist'},
      {n:'SK-99', name:'Jeffrey', artist:'Sketch Card Artist'},
      {n:'SK-100', name:'Jeffrey C. Benitez', artist:'Sketch Card Artist'},
      {n:'SK-101', name:'Jenna McGrath', artist:'Sketch Card Artist'},
      {n:'SK-102', name:'Jenny Kim', artist:'Sketch Card Artist'},
      {n:'SK-103', name:'Jessica Hickman', artist:'Sketch Card Artist'},
      {n:'SK-104', name:'Jessica Van Dusen', artist:'Sketch Card Artist'},
      {n:'SK-105', name:'Jesus', artist:'Sketch Card Artist'},
      {n:'SK-106', name:'Jiaxin "YinShan" Sun', artist:'Sketch Card Artist'},
      {n:'SK-107', name:'Jim Dickson', artist:'Sketch Card Artist'},
      {n:'SK-108', name:'Jim O\'Riley', artist:'Sketch Card Artist'},
      {n:'SK-109', name:'Jodie Rae Charity', artist:'Sketch Card Artist'},
      {n:'SK-110', name:'John Boren', artist:'Sketch Card Artist'},
      {n:'SK-111', name:'John Bruce', artist:'Sketch Card Artist'},
      {n:'SK-112', name:'John Luchin', artist:'Sketch Card Artist'},
      {n:'SK-113', name:'John Pleak', artist:'Sketch Card Artist'},
      {n:'SK-114', name:'John Still', artist:'Sketch Card Artist'},
      {n:'SK-115', name:'Jojo Hilario', artist:'Sketch Card Artist'},
      {n:'SK-116', name:'Jon Mangini', artist:'Sketch Card Artist'},
      {n:'SK-117', name:'Jonathan Beistline', artist:'Sketch Card Artist'},
      {n:'SK-118', name:'Josh Rosland', artist:'Sketch Card Artist'},
      {n:'SK-119', name:'Joshua Whitten', artist:'Sketch Card Artist'},
      {n:'SK-120', name:'Julia McKenzie', artist:'Sketch Card Artist'},
      {n:'SK-121', name:'Julie-Anne', artist:'Sketch Card Artist'},
      {n:'SK-122', name:'JUN DIAZ', artist:'Sketch Card Artist'},
      {n:'SK-123', name:'Jungle', artist:'Sketch Card Artist'},
      {n:'SK-124', name:'Kang Jing', artist:'Sketch Card Artist'},
      {n:'SK-125', name:'Karl Jones', artist:'Sketch Card Artist'},
      {n:'SK-126', name:'Kevin P. West', artist:'Sketch Card Artist'},
      {n:'SK-127', name:'Kevin Scott Jacobs', artist:'Sketch Card Artist'},
      {n:'SK-128', name:'Khloe Delnick', artist:'Sketch Card Artist'},
      {n:'SK-129', name:'Kris Penix', artist:'Sketch Card Artist'},
      {n:'SK-130', name:'Kyle Babbitt', artist:'Sketch Card Artist'},
      {n:'SK-131', name:'Kyle Sweeney', artist:'Sketch Card Artist'},
      {n:'SK-132', name:'Layton Scarbrough', artist:'Sketch Card Artist'},
      {n:'SK-133', name:'Lee Lightfoot', artist:'Sketch Card Artist'},
      {n:'SK-134', name:'Leon Braojos', artist:'Sketch Card Artist'},
      {n:'SK-135', name:'LH (Lisa Hall)', artist:'Sketch Card Artist'},
      {n:'SK-136', name:'Limuel Pinzon', artist:'Sketch Card Artist'},
      {n:'SK-137', name:'Loc Nguyen', artist:'Sketch Card Artist'},
      {n:'SK-138', name:'Luke Rushton LR', artist:'Sketch Card Artist'},
      {n:'SK-139', name:'Marcia Dye', artist:'Sketch Card Artist'},
      {n:'SK-140', name:'Marlo Agunos', artist:'Sketch Card Artist'},
      {n:'SK-141', name:'Marlo Martos', artist:'Sketch Card Artist'},
      {n:'SK-142', name:'Matt Steffens', artist:'Sketch Card Artist'},
      {n:'SK-143', name:'Matt Stewart', artist:'Sketch Card Artist'},
      {n:'SK-144', name:'Matthew Maldonado', artist:'Sketch Card Artist'},
      {n:'SK-145', name:'Matthew Skillern', artist:'Sketch Card Artist'},
      {n:'SK-146', name:'Mayumi Seto', artist:'Sketch Card Artist'},
      {n:'SK-147', name:'Michael Foster', artist:'Sketch Card Artist'},
      {n:'SK-148', name:'Michael Mastermaker', artist:'Sketch Card Artist'},
      {n:'SK-149', name:'Michael W. Foreman II', artist:'Sketch Card Artist'},
      {n:'SK-150', name:'Michelle Rayner', artist:'Sketch Card Artist'},
      {n:'SK-151', name:'Mike Dalzell', artist:'Sketch Card Artist'},
      {n:'SK-152', name:'Mike J Sealie', artist:'Sketch Card Artist'},
      {n:'SK-153', name:'Mike James', artist:'Sketch Card Artist'},
      {n:'SK-154', name:'Mike Stephens', artist:'Sketch Card Artist'},
      {n:'SK-155', name:'Mohammad Jilani', artist:'Sketch Card Artist'},
      {n:'SK-156', name:'Nadz', artist:'Sketch Card Artist'},
      {n:'SK-157', name:'Nathaniel Howard', artist:'Sketch Card Artist'},
      {n:'SK-158', name:'Neil A Brady', artist:'Sketch Card Artist'},
      {n:'SK-159', name:'Neil Camera', artist:'Sketch Card Artist'},
      {n:'SK-160', name:'Nick Gribbon', artist:'Sketch Card Artist'},
      {n:'SK-161', name:'Niño John Benitez', artist:'Sketch Card Artist'},
      {n:'SK-162', name:'Oscar Chavez', artist:'Sketch Card Artist'},
      {n:'SK-163', name:'Patricio Carrasco', artist:'Sketch Card Artist'},
      {n:'SK-164', name:'Patrick Giles', artist:'Sketch Card Artist'},
      {n:'SK-165', name:'Paul Williams', artist:'Sketch Card Artist'},
      {n:'SK-166', name:'Peejay Catacutan', artist:'Sketch Card Artist'},
      {n:'SK-167', name:'Phil Hassewer', artist:'Sketch Card Artist'},
      {n:'SK-168', name:'Phillip Trujillo', artist:'Sketch Card Artist'},
      {n:'SK-169', name:'Rebeca Louro', artist:'Sketch Card Artist'},
      {n:'SK-170', name:'Rees Chua-Finlay', artist:'Sketch Card Artist'},
      {n:'SK-171', name:'Rich Hennemann', artist:'Sketch Card Artist'},
      {n:'SK-172', name:'Rico Dela Rosa', artist:'Sketch Card Artist'},
      {n:'SK-173', name:'Rob Demers', artist:'Sketch Card Artist'},
      {n:'SK-174', name:'Robert Hendrickson', artist:'Sketch Card Artist'},
      {n:'SK-175', name:'Ross', artist:'Sketch Card Artist'},
      {n:'SK-176', name:'Roy Cover', artist:'Sketch Card Artist'},
      {n:'SK-177', name:'Rustico Limosinero', artist:'Sketch Card Artist'},
      {n:'SK-178', name:'Rusty!', artist:'Sketch Card Artist'},
      {n:'SK-179', name:'Rutvig Vaid', artist:'Sketch Card Artist'},
      {n:'SK-180', name:'Ryan Crosby', artist:'Sketch Card Artist'},
      {n:'SK-181', name:'Ryan Finley', artist:'Sketch Card Artist'},
      {n:'SK-182', name:'Ryan Olsen', artist:'Sketch Card Artist'},
      {n:'SK-183', name:'Ryan Thompson', artist:'Sketch Card Artist'},
      {n:'SK-184', name:'Sammy Gomez', artist:'Sketch Card Artist'},
      {n:'SK-185', name:'Sandy Meeks', artist:'Sketch Card Artist'},
      {n:'SK-186', name:'Scott Hattox', artist:'Sketch Card Artist'},
      {n:'SK-187', name:'Scott Houseman', artist:'Sketch Card Artist'},
      {n:'SK-188', name:'Scott Rorie', artist:'Sketch Card Artist'},
      {n:'SK-189', name:'Scribbling Joe', artist:'Sketch Card Artist'},
      {n:'SK-190', name:'Sean Earey', artist:'Sketch Card Artist'},
      {n:'SK-191', name:'Sean Mathews', artist:'Sketch Card Artist'},
      {n:'SK-192', name:'Semra Bulut', artist:'Sketch Card Artist'},
      {n:'SK-193', name:'Shaow Siong', artist:'Sketch Card Artist'},
      {n:'SK-194', name:'Sir Edmund Duke', artist:'Sketch Card Artist'},
      {n:'SK-195', name:'Snorpixel', artist:'Sketch Card Artist'},
      {n:'SK-196', name:'Stephane Leonardi', artist:'Sketch Card Artist'},
      {n:'SK-197', name:'Steve Alce', artist:'Sketch Card Artist'},
      {n:'SK-198', name:'Steven Smith', artist:'Sketch Card Artist'},
      {n:'SK-199', name:'T Agar', artist:'Sketch Card Artist'},
      {n:'SK-200', name:'Ted Dastick Jr', artist:'Sketch Card Artist'},
      {n:'SK-201', name:'Tim Shinn', artist:'Sketch Card Artist'},
      {n:'SK-202', name:'Todd Aaron Smith', artist:'Sketch Card Artist'},
      {n:'SK-203', name:'Tom Amici', artist:'Sketch Card Artist'},
      {n:'SK-204', name:'TOMA', artist:'Sketch Card Artist'},
      {n:'SK-205', name:'Tomoko Taniguchi', artist:'Sketch Card Artist'},
      {n:'SK-206', name:'Tony Riley', artist:'Sketch Card Artist'},
      {n:'SK-207', name:'Traci Easterday', artist:'Sketch Card Artist'},
      {n:'SK-208', name:'Tyler Newcomb', artist:'Sketch Card Artist'},
      {n:'SK-209', name:'Veronica Louro', artist:'Sketch Card Artist'},
      {n:'SK-210', name:'Veronica Smith', artist:'Sketch Card Artist'},
      {n:'SK-211', name:'Vini Pirani', artist:'Sketch Card Artist'},
      {n:'SK-212', name:'W Green', artist:'Sketch Card Artist'},
      {n:'SK-213', name:'Ward Silverman', artist:'Sketch Card Artist'},
      {n:'SK-214', name:'William ROGER', artist:'Sketch Card Artist'},
      {n:'SK-215', name:'yungmilllz', artist:'Sketch Card Artist'},
      {n:'SK-216', name:'Yves Van Berlo', artist:'Sketch Card Artist'},
      {n:'SK-217', name:'Zach Woolsey', artist:'Sketch Card Artist'},
      {n:'SK-218', name:'ジェイソン (Jason)', artist:'Sketch Card Artist'},
    ]
  },
];
export const PARALLELS = [
  { id: 'refractor', name: 'Refractor', print_run: null, color: '#c8d8f0' },
  { id: 'mini-diamond', name: 'Mini-Diamond Refractor', print_run: null, color: '#b0e0ff' },
  { id: 'magenta-lava', name: 'Magenta Lava Refractor', print_run: 250, color: '#ff40a0' },
  { id: 'green-shimmer', name: 'Green Shimmer Refractor', print_run: 199, color: '#00e87a' },
  { id: 'green-kaleidoscope', name: 'Green Kaleidoscope Refractor', print_run: 199, color: '#8bc34a' },
  { id: 'blue-ray-wave', name: 'Blue Ray Wave Refractor', print_run: 175, color: '#2979ff' },
  { id: 'atomic', name: 'Atomic Refractor', print_run: 150, color: '#00bcd4' },
  { id: 'purple-speckle', name: 'Purple Speckle Refractor', print_run: 125, color: '#b060ff' },
  { id: 'wave', name: 'Wave Refractor', print_run: 99, color: '#00b0ff' },
  { id: 'logofractor-77', name: 'Star Wars Logofractor', print_run: 77, color: '#c9a227' },
  { id: 'prism', name: 'Prism Refractor', print_run: 75, color: '#e040fb' },
  { id: 'mojo', name: 'Mojo Refractor', print_run: 50, color: '#ff6d00' },
  { id: 'orange', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
  { id: 'xfractor', name: 'X-Fractor', print_run: 10, color: '#76ff03' },
  { id: 'red-logofractor', name: 'Star Wars Red Logofractor', print_run: 5, color: '#ff1744' },
  { id: 'red', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];
export const AUTO_PARALLELS = [
  { id: 'atomic', name: 'Atomic Refractor', print_run: 150, color: '#00bcd4' },
  { id: 'wave', name: 'Wave Refractor', print_run: 99, color: '#00b0ff' },
  { id: 'mojo', name: 'Mojo Refractor', print_run: 50, color: '#ff6d00' },
  { id: 'orange', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
  { id: 'red', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];
export const INSERT_PARALLELS = [
  { id: 'green-shimmer', name: 'Green Shimmer Refractor', print_run: 199, color: '#00e87a' },
  { id: 'blue-ray-wave', name: 'Blue Ray Wave Refractor', print_run: 175, color: '#2979ff' },
  { id: 'atomic', name: 'Atomic Refractor', print_run: 150, color: '#00bcd4' },
  { id: 'wave', name: 'Wave Refractor', print_run: 99, color: '#00b0ff' },
  { id: 'prism', name: 'Prism Refractor', print_run: 75, color: '#e040fb' },
  { id: 'mojo', name: 'Mojo Refractor', print_run: 50, color: '#ff6d00' },
  { id: 'orange', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
  { id: 'xfractor', name: 'X-Fractor', print_run: 10, color: '#76ff03' },
  { id: 'red', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];
